import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';

import type { PostBootstrapInit } from './post-bootstrap-init';

@Injectable({
  providedIn: 'root'
})
export class MaterialService implements PostBootstrapInit {
  private readonly matIconRegistry = inject<MatIconRegistry>(MatIconRegistry);

  init(): void {
    this.matIconRegistry.setDefaultFontSetClass('td-icon');
  }
}
